import React, {Component, Fragment} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Form, Segment, Header, Grid, Divider, ItemGroup} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {MOMENT_EST} from 'app-ui-componentlibrary/dist/common/constants';
import {ISOToDisplayDate} from 'common/utils';
import {ContentDispatch} from 'framework';
import {RadioField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {Alert} from 'componentLibrary';
import {isAOR} from 'go/security/permissions';
import AuthSubmitWrapper from 'go/components/dynamic/modules/form/submitWrappers/AuthSubmitWrapper';
import AssignSubmitWrapper from 'go/components/dynamic/modules/form/submitWrappers/AssignSubmitWrapper';
import {UpdateEntityWrapper} from 'go/components/dynamic/modules/form/submitWrappers/UpdateEntityWrapper';
import {DynamicReviewAttachmentsConnected as DynamicReviewAttachments} from 'componentLibrary';
import {ConfigNameValue as NameValue} from 'componentLibrary';
import {CLEAR_ALL_MSG, ADD_MSG} from 'common/types';
import moment from 'moment-timezone';
import CommentList from 'go/components/comments/CommentList';

const DETERMINATION = 'determination';
const COMMENT = 'comment';
const DeterminationRadio = ({data, handleChange, label}) => {
  const decisionOptions = [
    {label: 'Accept award', value: 'Accept award'},
    {label: 'Decline award', value: 'Decline award'},
  ];
  return (
    <RadioField
      label={label}
      options={decisionOptions}
      value={_.get(data, DETERMINATION)}
      handleChange={(e, data) => handleChange(DETERMINATION, data.value)}
    />
  );
};

const formatDateForAcceptance = (date) => {
  const dateConfig = {
    showDate: true,
    describeMonth: true,
    useUserTimezone: true,
  };
  const timeConfig = {
    useUserTimezone: true,
    twentyFour: false,
    showDate: false,
    showHours: true,
  };
  return {
    date: ISOToDisplayDate(date, dateConfig),
    hours: ISOToDisplayDate(date, timeConfig),
  };
};

export class AwardAcceptance extends Component {
  componentDidMount() {
    this.props.clearAllMsg();
  }

  handleChange = (name, value) => {
    this.props.saveEntityData(
      `${this.props.entityDataPath}.${name}`,
      this.props.entityType,
      value
    );
  };

  getSignedAwardRec = () => {
    const {awardRecommendation} = this.props;
    let awardRecommendationUpdated = _.cloneDeep(awardRecommendation);
    const signature = {
      userId: this.props.userId,
      timestamp: moment.tz(moment.tz.guess() || MOMENT_EST).format(),
    };
    _.set(awardRecommendationUpdated, 'payload.signed.recipient', signature);
    return awardRecommendationUpdated;
  };

  renderSubmitButton = () => {
    const {
      data,
      dueDate,
      isAOR,
      submitConfig,
      firstName,
      lastName,
      handleSubmit,
      addMessage,
      saveEntitySessionData,
    } = this.props;
    const missingPhoneNumber = _.isEmpty(this.props.phoneNumbers);
    const disableText = !isAOR
      ? 'You must be an AOR for your organization to accept or decline an award.'
      : missingPhoneNumber
      ? 'You must update your profile to include a phone number before accepting or declining the award.'
      : 'You must provide all of the required information on this page before accepting or declining the award.';
    const {date: dueDateFormatted, hours: dueHours} = formatDateForAcceptance(dueDate);
    const currentDate = moment().format('MM/DD/YYYY');
    const determination = _.get(data, DETERMINATION);

    const awardRecDataPath = _.find(
      this.props.dependencies,
      (dep) => dep.awardRecommendation != undefined
    ).awardRecommendation;

    return (
      <UpdateEntityWrapper
        handleSubmit={handleSubmit}
        getEntity={() => [
          {entityDataPath: awardRecDataPath, entity: this.getSignedAwardRec()},
        ]}
        token={this.props.token}
        saveEntitySessionData={saveEntitySessionData}
      >
        {(handleSubmitAfterUpdate) => (
          <AssignSubmitWrapper handleSubmit={handleSubmitAfterUpdate}>
            {(handleSubmitAfterAssign) => (
              <AuthSubmitWrapper
                confirmationLabel={`I, ${firstName} ${lastName}, am hereby providing my signature for this award as of ${currentDate}.`}
                handleSubmit={handleSubmitAfterAssign}
              >
                {(handleSubmitWithAuth, isValid) => (
                  <ContentDispatch
                    config={submitConfig}
                    isDisabled={missingPhoneNumber || !isValid || !isAOR}
                    handlePostSubmit={() => {
                      determination === 'Accept award'
                        ? addMessage(`You have successfully accepted your award.`)
                        : addMessage(`You have successfully declined your award.`);
                    }}
                    disableText={disableText}
                    data={data}
                    handleSubmit={handleSubmitWithAuth}
                  />
                )}
              </AuthSubmitWrapper>
            )}
          </AssignSubmitWrapper>
        )}
      </UpdateEntityWrapper>
    );
  };

  render() {
    const {
      acceptContents,
      declineContents,
      reminderContents,
      instructionsContents,
      awardStatusContents,
      data,
      isAOR,
      phoneNumbers,
      periodOfPerformance,
      dueDate,
      grantId,
      subGrantId,
      organizationId,
      fedShare,
    } = this.props;

    const missingPhoneNumber = _.isEmpty(phoneNumbers);
    const popConfig = {showDate: true, showHours: false};
    const startDate = ISOToDisplayDate(
      _.get(periodOfPerformance, 'startDate'),
      popConfig
    );
    const endDate = ISOToDisplayDate(_.get(periodOfPerformance, 'endDate'), popConfig);
    const {date: dueDateFormatted, hours: dueHours} = formatDateForAcceptance(dueDate);
    const determinationLabelSubAward = (
      <Fragment>
        <strong>
          Please accept or decline your award by {dueDateFormatted} at {dueHours}
        </strong>
        <p style={{fontWeight: 'normal'}}>
          The user who accepts this award will become the Authorized Organization
          Representative (AOR) for the grant and will receive permission to submit
          payment requests, amendment requests, and reports to FEMA post-award. The award
          package and the award appendix, including the obligating document, will be updated to include the AOR
          for the grant upon award acceptance.
        </p>
      </Fragment>
    );
    const determinationLabel =!_.isNil(subGrantId)? determinationLabelSubAward: (
      <Fragment>
        <strong>
          Please accept or decline your award by {dueDateFormatted} at {dueHours}
        </strong>
        <p style={{fontWeight: 'normal'}}>
          The user who accepts this award will become the Authorized Organization
          Representative (AOR) for the grant and will receive permission to submit
          payment requests, amendment requests, and reports to FEMA post-award. The award
          package, including the obligating document, will be updated to include the AOR
          for the grant upon award acceptance.
        </p>
      </Fragment>
    );
    const determination = _.get(data, DETERMINATION);
    const comment = _.get(this.props, COMMENT);
    let isNotEmptyComment= this.props.hideEmptyComment ? (comment[0] != null):true;
    return (
      <div>
        {/* TODO, replace everything above the Divider with new config driven RecipientTaskHeader component */}
        <Grid columns={2}>
          <Grid.Column>
            <p>
              Period of performance: <strong>{startDate}</strong> to{' '}
              <strong>{endDate}</strong>
            </p>
          </Grid.Column>
          <Grid.Column textAlign="right">
            Federal share: <strong className="color--success">{fedShare}</strong>
          </Grid.Column>
        </Grid>
        <Divider />
        <h2>Award acceptance</h2>
        <Alert type="warning" header="Award status">
          <p>
            Please note that you have until <strong>{dueDateFormatted}</strong> at{' '}
            <strong>{dueHours}</strong> to either accept or decline the award.
          </p>
          {!awardStatusContents &&(
            <p>
              If no action is taken by the award acceptance due date of{' '}
              <strong>{dueDateFormatted}</strong> at <strong>{dueHours}</strong>, the
              system will retract this notification; if additional time is needed please
              contact the AFG Help Desk at 1-866-274-0960 for instructions.
            </p>
          )}
          {_.map(awardStatusContents, (content, index) => (
            <ContentDispatch config={content} key={index} />
          ))}
        </Alert>
        <Segment>
          <Alert type="info" header="Instructions">
            {_.map(instructionsContents, (content, index) => (
              <ContentDispatch config={content} key={'instructions-' + index} />
            ))}
          </Alert>
          {comment && isNotEmptyComment && (
            <Fragment>
              <Header as="h2">Comments</Header>
              <Segment>
                <Grid>
                  <CommentList comments={comment} />
                </Grid>
              </Segment>
            </Fragment>
          )}
          <Header as="h2">Accept or decline award</Header>
          <Grid>
            <Grid.Row>
              <Grid.Column mobile={16} tablet={8} computer={5}>
                <ItemGroup>
                  <NameValue name="Grant ID:" data={grantId} />
                  <NameValue
                    name="Period of performance:"
                    data={`${startDate} - ${endDate}`}
                  />
                  <NameValue name="Federal share:" data={fedShare} />
                </ItemGroup>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={16}>
                <Header as="h4">Download award package</Header>
                <DynamicReviewAttachments
                  attachmentType="Award Package"
                  header="Award Package"
                  showAttachmentType={true}
                  readOnly={true}
                  entityId={grantId}
                  entityType="grant"
                />
              </Grid.Column>
              {subGrantId != null && (
              <Grid.Column width={16}>
                <Header as="h4">Download award appendix</Header>
                <DynamicReviewAttachments
                  attachmentType="Award Appendix"
                  header="Award Appendix"
                  showAttachmentType={true}
                  readOnly={true}
                  entityId={subGrantId}
                  entityType="subGrant"
                />
              </Grid.Column>
              )}
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={16}>
                <Form>
                  {isAOR && missingPhoneNumber && (
                    <Alert type="error" header={'Update your profile'}>
                      You must update your profile before signing for the award. Please
                      use the{' '}
                      <Link to="/profile" title="Your profile page">
                        Your Profile
                      </Link>{' '}
                      page to provide a phone number by which FEMA can contact you about
                      the award as needed.
                    </Alert>
                  )}
                  {!isAOR && subGrantId == null && (
                    <Alert type="error" header={'Not authorized to sign'}>
                      You are unable to sign this award, as you are not an AOR for this
                      organization. Please contact one of your{' '}
                      <Link
                        to={`/organizations/${organizationId}`}
                        title="Your organization page"
                      >
                        organization's AORs
                      </Link>
                      .
                    </Alert>
                  )}
                  {!isAOR && subGrantId != null && (
                    <Alert type="error" header={'Not authorized to sign'}>
                      You are unable to sign this award since you are not an AOR for this organization. Please contact one of your{' '}
                      <Link
                        to={`/organizationsPage`}
                        title="Your organization page"
                      >
                        organization's AORs
                      </Link>
                      .
                    </Alert>
                  )}
                  <DeterminationRadio
                    data={data}
                    handleChange={this.handleChange}
                    label={determinationLabel}
                  />
                  {determination === 'Accept award' && (
                    <div className="border-line--success">
                      {_.map(acceptContents, (content, index) => (
                        <ContentDispatch
                          config={content}
                          key={'accept-' + content.id || index}
                        />
                      ))}
                      {this.renderSubmitButton()}
                    </div>
                  )}
                  {determination === 'Decline award' && (
                    <div className="border-line--error">
                      {_.map(declineContents, (content, index) => (
                        <ContentDispatch
                          config={content}
                          key={'decline-' + content.id || index}
                        />
                      ))}
                      {this.renderSubmitButton()}
                    </div>
                  )}
                </Form>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                {_.map(reminderContents, (content, index) => (
                  <ContentDispatch config={content} key={'reminder-' + index} />
                ))}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    token: _.get(state, 'auth.token'),
    isAOR: isAOR(_.get(state, 'auth.permissions')),
    phoneNumbers: _.get(state, 'profile.phoneNumbers'),
    firstName: _.get(state, 'profile.firstName'),
    lastName: _.get(state, 'profile.lastName'),
    userId: _.get(state, 'profile.userId'),
    comment: _.get(state, 'dynamicComponent.context.comment'),
  };
};

export const mapDispatchToProps = (dispatch) => ({
  clearAllMsg: () => {
    dispatch({type: CLEAR_ALL_MSG});
  },
  addMessage: (msg) => {
    dispatch({
      type: ADD_MSG,
      msg: msg,
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectDynamic(AwardAcceptance));
